import useSwr from 'swr';
import useCommonDeviceDataService from '../../patch-view/services/common-device-data-service/useCommonDeviceDataService';
import { useSelector } from 'react-redux';
import { selectJwt } from '../../ui-frame/state/ui-frame.slice';
import { Device } from 'synapse-common-device-service';

const useDevice = (deviceId: string): { data?: Device; error?: Error } => {
  const { commonDeviceDataService, isCommonDeviceDataServiceReady } = useCommonDeviceDataService();
  const jwtToken = useSelector(selectJwt);

  commonDeviceDataService.setToken(jwtToken);
  const { data: devices, error } = useSwr(
    isCommonDeviceDataServiceReady ? ['getDevices', deviceId] : null,
    () => commonDeviceDataService.getDevices({ deviceIds: [deviceId] }),
    {
      shouldRetryOnError: false
    }
  );
  return { data: devices?.[0], error };
};

export default useDevice;
